import React, {Component} from 'react';
import {__, __n} from "i18n-for-browser";
import PropTypes from 'prop-types';
import ContentContainer from "./ContentContainer";

import Repeat from '../../assets/img/icons/repeat_arrow.svg';
import Play from '../../assets/img/icons/play_arrow_white.svg';
import Pause from '../../assets/img/icons/pause_icon_white.svg';

class ClassLeaderTimerView extends Component {
  static propTypes = {
    minDouble: PropTypes.number,
    minSingle: PropTypes.number,
    secDouble: PropTypes.number,
    secSingle: PropTypes.number,
  };

  static defaultProps = {
    minDouble: 0,
    minSingle: 0,
    secDouble: 0,
    secSingle: 0,
  };

  constructor(props) {
    super(props);
    this.state = {
      editingInput: false,
    };
  }

  handleInputChange = (e, key, confirmed) => {
    if(this.props.isRunning) return;
    this.props.handleInput(e, key, confirmed);
  }

  handleFocus = (ev)=> {
    ev.target.value = '';
  };

  render() {
    return (
      <div>
        <ContentContainer className="classLeaderCountdown">
          <div className={"heading"}>
            <h3>{__('sim_globatimer')}</h3>
            <p>{__('sim_begleider_timer_omschrijving')}</p>
          </div>
          <div className={"timer"}>
            <div className={"digits"}>
              <input onFocus={this.handleFocus} type="number" className={"digit"} onChange={(e) => this.handleInputChange(e, "minDouble", false)} onBlur={(e) => this.handleInputChange(e, "minDouble", true)} value={this.props.minDouble}/>
              <input onFocus={this.handleFocus} type="number" className={"digit"} onChange={(e) => this.handleInputChange(e, "minSingle", false)} onBlur={(e) => this.handleInputChange(e, "minSingle", true)} value={this.props.minSingle}/>
              <p className={"label"}>{__n('sim_minuut', 0)}</p>
            </div>
            <div className={"seperator"}>
              <span>:</span>
            </div>
            <div className={"digits"}>
              <input onFocus={this.handleFocus} type="number" className={"digit"} onChange={(e) => this.handleInputChange(e, "secDouble", false)} onBlur={(e) => this.handleInputChange(e, "secDouble", true)} value={this.props.secDouble}/>
              <input onFocus={this.handleFocus} type="number" className={"digit"} onChange={(e) => this.handleInputChange(e, "secSingle", false)} onBlur={(e) => this.handleInputChange(e, "secSingle", true)} value={this.props.secSingle}/>
              <p className={"label"}>{__n('sim_seconde', 0)}</p>
            </div>
          </div>
          <div className={"controls"}>
            <div onClick={() => this.props.handleClearTimer()} className={"timerControl red"}>
              <img src={Repeat} alt={'repeat'}/>
            </div>
            <div onClick={() => this.props.handleRunningToggle()} className={"timerControl blue"}>
              {this.props.isRunning ? <img src={Pause} alt={'repeat'}/> : <img src={Play} alt={'repeat'}/>}
            </div>
          </div>
        </ContentContainer>
        <div className={'bg-color'} onClick={this.props.toggleFlipCountDownDropdown}/>
      </div>
    )
  }
}

export default ClassLeaderTimerView;



// WEBPACK FOOTER //
// ./src/components/elements/ClassLeaderTimerView.js